import { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import Spinner from "../../components/common/Spinner";

export default function RequireAdmin({ children }) {
    const [user, loading] = useAuthState(auth);
    const [isAdmin, setIsAdmin] = useState(null);
    const navigate = useNavigate();
    const ADMIN_UID = "8gNO0moOfrVZy6cc5p7RLkeAOeg2"; // jouw admin UID

    // console.log("UID van ingelogde gebruiker:", auth.currentUser?.uid);

    useEffect(() => {
        const checkAdmin = async () => {
            if (user.uid === ADMIN_UID) {
                setIsAdmin(true);
                return;
            }

            const userRef = doc(db, "users", user.uid);
            const userSnap = await getDoc(userRef);

            if (userSnap.exists() && userSnap.data().isAdmin) {
                setIsAdmin(true);
            } else {
                setIsAdmin(false);
                navigate("/"); // geen toegang
            }
        };

        if (!loading && user) {
            checkAdmin();
        } else if (!loading && !user) {
            navigate("/login");
        }
    }, [user, loading, navigate]);

    if (loading || isAdmin === null) return <Spinner />;

    return children;
}
